// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"EpisodeDemographics_wrapper__NEbuu","container":"EpisodeDemographics_container__3sZ9a"};